import React from 'react';

import { DotIcon } from '@vlabs/icons';
import cn from 'classnames';

import st from './shared.module.sass';
import { getStreamStatusConfig } from './streamStatusConfig';

interface AnalyticStatusProps {
  /** Статус аналитики — совпадает со статусом источника (число StreamStatusValue). */
  status: number;
  /** Название аналитики (переведённый тип). */
  name?: string;
  /** Порядковый номер аналитики. */
  number?: string;
  className?: string;
  'data-testid'?: string;
}

function AnalyticStatus({
  status,
  name = undefined,
  number = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: AnalyticStatusProps): React.JSX.Element {
  const statusConfig = getStreamStatusConfig(status);

  const hasName = name !== undefined || number !== undefined;

  return (
    <div
      className={cn(st.AnalyticStatus, !hasName && st.AnalyticStatus_compact, className)}
      data-testid={dataTestId}
    >
      {!!hasName && (
        <span className={st.AnalyticStatusName}>
          {name !== undefined && <span className={st.AnalyticStatusNameText}>{name}</span>}
          {!!number && <span className={st.AnalyticStatusNumber}>{number}</span>}
        </span>
      )}

      <span className={cn(st.AnalyticStatusTag, statusConfig.textColorClass)}>
        <DotIcon className={st.AnalyticStatusDot} />
        <span className={st.AnalyticStatusTagText}>{statusConfig.label}</span>
      </span>
    </div>
  );
}

export { AnalyticStatus };
